import Konva from 'konva';

function getTokensInString(text: string) {
    if (typeof text === 'string') {
        const result = [];
        const tokens = text.split(/[\s\n]+/);
        for (const token of tokens) {
            if (token.length > 0) {
                result.push(token);
            }
        }
        return result;
    }
    return [];
}

function hasBrokenWords(sourceTokens: string[], renderLines: { text: string; width: number }[]) {
    let combined = '';
    for (let i = 0; i < renderLines.length; i++) {
        combined += (i === 0 ? '' : ' ') + renderLines[i].text;
    }

    const a = sourceTokens;
    const b = getTokensInString(combined);

    if (a.length !== b.length) {
        return true;
    }

    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return true;
        }
    }

    return false;
}

export function ShrinkText(textNode: Konva.Text, minFontSize: number) {
    const sourceTokens = getTokensInString((textNode.attrs as Record<string, string>)['text']);
    let brokenWords = hasBrokenWords(sourceTokens, textNode.textArr);

    let textHeight = textNode.textArr.length * textNode.textHeight;
    let textAreaHeight = textNode.height();

    while ((textHeight > textAreaHeight || brokenWords) && textNode.fontSize() > minFontSize) {
        textNode.fontSize(textNode.fontSize() - 1);

        //update conditions
        brokenWords = hasBrokenWords(sourceTokens, textNode.textArr);
        textHeight = textNode.textArr.length * textNode.textHeight;
        textAreaHeight = textNode.height();
    }

    return textNode.fontSize();
}